// extracted by mini-css-extract-plugin
export var centerText = "_5g-8";
export var container = "_5g-0";
export var doughnutContainer = "_5g-7";
export var legend = "_5g-a";
export var legendItemColorDisplay = "_5g-b";
export var legendItemLabel = "_5g-d";
export var legendItemValue = "_5g-c";
export var lg = "_5g-5";
export var maxWidth = "_5g-9";
export var md = "_5g-4";
export var responsive = "_5g-6";
export var sm = "_5g-3";
export var xs = "_5g-2";
export var xxs = "_5g-1";